import React, { FC } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "antd";
import { useAuth } from "../../hooks";
import { PageLoading } from "../../components/page-loading";

export const Login: FC<{ ssrHost?: string }> = ({ ssrHost }) => {
  const { error, isLoading, isAuthenticated, login } = useAuth(ssrHost);

  const loginButton = (
    <Button type="primary" size="large" onClick={() => login()}>
      Login
    </Button>
  );

  return (
    <PageLoading loading={isLoading} error={error}>
      {isAuthenticated ? <Navigate to="/" /> : loginButton}
    </PageLoading>
  );
};
